import { call, put, takeLatest } from "redux-saga/effects";
import { httpGenerateQuestions } from "../../../services/questions";
import {
  aiCreateQuestionStart,
  aiCreateQuestionSuccess,
  aiCreateQuestionFailure,
} from "../reducer";

import { networkErrorHandler } from "../../../utils/errorHandlers";

export function* generateQuestions({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpGenerateQuestions, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(aiCreateQuestionSuccess(raw));

    if (callback) {
      callback();
    }
  } else {
    yield put(aiCreateQuestionFailure(message || raw));
    networkErrorHandler(response.statusCode, message || raw);
  }
}

export default function* onGenerateQuestions() {
  yield takeLatest(aiCreateQuestionStart.type, generateQuestions);
}
